import React from 'react';
import { compose } from 'redux';
import { useSelector } from 'react-redux';

import __DEPRECATED_defineResources from 'dpl/shared/fetching/deprecated/defineResources';
import { CONSTRAINT_TYPES } from 'dpl/shared/validations/constraints';
import withFormCapabilities from 'dpl/form/decorators/withFormCapabilities';
import UserAuthResetPasswordForm from 'dpl/UserAuth/components/UserAuthResetPasswordForm';

function UserAuthResetPasswordFormContainer(props) {
  const unverifiedLogin = useSelector(
    ({ queryParams }) => queryParams.unverified_login === 'true'
  );
  return (
    <UserAuthResetPasswordForm unverifiedLogin={unverifiedLogin} {...props} />
  );
}

export default compose(
  __DEPRECATED_defineResources((state, props) => ({
    sessionData: {
      url: '/api/users/password.json',
      auto: false,
      actions: {
        submit: (userData, additionalParams) => ({
          method: 'PUT',
          url: '/api/users/password.json',
          body: {
            ...additionalParams,
            user: {
              ...userData,
              reset_password_token: props.match.params.resetToken
            }
          }
        })
      }
    }
  })),
  withFormCapabilities(() => ({}), {
    onSubmit: (props, formStateForSubmission, additionalParams) =>
      props.sessionData.submit(formStateForSubmission, additionalParams),
    mapPropsAndStateToValidationSchema: (_, formState) => ({
      password: CONSTRAINT_TYPES.PASSWORD,
      password_confirmation: formState.password_confirmation
        ? {
            presence: true,
            equality: {
              attribute: 'password',
              message: "Passwords don't match"
            }
          }
        : CONSTRAINT_TYPES.TEXT
    })
  })
)(UserAuthResetPasswordFormContainer);
